import axios from 'axios'
// import { Message, Loading } from 'element-ui'
import { Message } from 'element-ui'
import store from '../store'
import Cookies from 'js-cookie'
import { i18n } from '@/lang'
axios.defaults.withCredentials = false // 不携带cookie
// 创建axios实例
const service = axios.create({
  // baseURL: '/api', // api 的 base_url
  // baseURL: process.env.BASE_API,
  baseURL: window.glob.baseUrl,
  timeout: 100000 // 请求超时时间
})
// var loading = ''
// request拦截器
service.interceptors.request.use(config => {
  const userPermissions = store.getters.permissions
  if (userPermissions.length > 0) { // 有userPermissions说明是登录，非登录状态下不校验权限
    // 校验接口权限白名单
    let whiteMenu = ['/auth/login', '/auth/user/getInfo']
    if (whiteMenu.indexOf(config.url) < 0) {
      if ((userPermissions.findIndex(i => i.url === config.url) > -1) || (store.state.user.loginName === 'admin')) {
      // 有权限
      } else {
      // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          message: config.url + i18n.t('lang.无权限'),
          response: 'error'
        })
      }
    }
  }
  config.headers['Accept-Language'] = Cookies.get('language') ? Cookies.get('language') : 'zh'
  if (sessionStorage.getItem('token')) { // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    config.headers.Authorization = JSON.parse(sessionStorage.getItem('token'))
  }
  return config
}, error => {
  // Do something with request error
  console.error(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.status === 401) {
      sessionStorage.removeItem('token')
      location.reload()
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|phone|pad|pod|ios|Mobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|Symbian|Windows Phone/i.test(navigator.userAgent)) {
        this.$store.state.permission.addRouters = []
        this.$router.push({path: '/app/app_login'})
      }
    }
    // loading.close()
    const res = response.data
    if (res.code === 200) {
      return res
    } else if (res.code === 403 || res.code === 401) {
      Message({
        showClose: true,
        message: res.message ? res.message : '',
        type: 'error',
        duration: 500,
        onClose: () => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        }
      })
      return Promise.reject(new Error(i18n.t('lang.未登录')))
    } else {
      // Message({
      //   message: res.message,
      //   type: 'error',
      //   duration: 3 * 1000
      // })
      // return Promise.reject(res)
      return res
    }
  },
  error => {
    console.error('err' + error)// for debug
    if (!error.response) {
      store.dispatch('FedLogOut').then(() => {
        Message({
          message: i18n.t('lang.服务器未启动/响应错误'),
          type: 'error',
          duration: 3 * 1000
        })
        setTimeout(() => {
          sessionStorage.removeItem('token')
          location.reload()// 为了重新实例化vue-router对象 避免bug
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|phone|pad|pod|ios|Mobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|Symbian|Windows Phone/i.test(navigator.userAgent)) {
            this.$store.state.permission.addRouters = []
            this.$router.push({path: '/app/app_login'})
          }
        }, 1000)
      })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js